import { QueryFilter } from 'types/Filter';
import { TextSection, getListBlock, getParagraphBlock } from '@components/SearchEngineText';
import { FormattedMessage } from 'utils/intl';
import getListWithId from 'utils/getListWithId';

import { School } from './SchoolTrustedUs';
import messages from './EducationZone.messages';

export const sections: { name: string; constantFilters: QueryFilter[] }[] = [
  {
    name: 'Laptopy Dell',
    constantFilters: [
      { key: 'tags', values: ['Laptop dla edukacji'] },
      { key: 'product_type', values: ['Laptop'] },
    ],
  },
  {
    name: 'Komputery Dell',
    constantFilters: [
      { key: 'tags', values: ['Komputer dla edukacji'] },
      { key: 'product_type', values: ['Komputer'] },
    ],
  },
  {
    name: 'Monitory Dell',
    constantFilters: [
      { key: 'tags', values: ['Monitor dla edukacji'] },
      { key: 'product_type', values: ['Monitor'] },
    ],
  },
  {
    name: 'Akcesoria Dell',
    constantFilters: [{ key: 'tags', values: ['Akcesoria dla edukacji'] }],
  },
  {
    name: 'Urządzenia sieciowe',
    constantFilters: [{ key: 'tags', values: ['Łączność dla edukacji'] }],
  },
];

export const expertItems = getListWithId(
  [
    messages.expert1,
    messages.expert2,
    messages.expert3,
    messages.expert4,
    messages.expert5,
    messages.expert6,
    messages.expert7,
    messages.expert8,
  ].map((message) => ({
    message,
  }))
).map(({ message, id }) => ({ id, text: <FormattedMessage key={id} {...message} /> }));

export const searchEngineTexts: TextSection[] = [
  {
    header: messages.searchEngineHeader1,
    blocks: [getParagraphBlock(messages.searchEngineParagraph1)],
  },
  {
    header: messages.searchEngineHeader2,
    blocks: [getParagraphBlock(messages.searchEngineParagraph2)],
  },
  {
    header: messages.searchEngineHeader3,
    blocks: [getParagraphBlock(messages.searchEngineParagraph3)],
  },
  {
    header: messages.searchEngineHeader4,
    blocks: [getParagraphBlock(messages.searchEngineParagraph4)],
  },
  {
    header: messages.searchEngineHeader5,
    blocks: [getParagraphBlock(messages.searchEngineParagraph5)],
  },
  {
    header: messages.searchEngineHeader6,
    blocks: [getParagraphBlock(messages.searchEngineParagraph6)],
  },
  {
    header: messages.searchEngineHeader7,
    blocks: [getParagraphBlock(messages.searchEngineParagraph7)],
  },
  {
    header: messages.searchEngineHeader8,
    blocks: [
      getParagraphBlock(messages.searchEngineParagraph8),
      getListBlock([
        messages.computersForEverydayUsage,
        messages.complexComputerLabEquipment,
        messages.funcitonalMonitors,
        messages.preferentialProframsLaptops,
        messages.taxFreeShopping,
      ]),
    ],
  },
  {
    header: messages.searchEngineHeader9,
    blocks: [getParagraphBlock(messages.searchEngineParagraph9)],
  },
  {
    header: messages.searchEngineHeader10,
    blocks: [getParagraphBlock(messages.searchEngineParagraph10)],
  },
  {
    header: messages.searchEngineHeader11,
    blocks: [getParagraphBlock(messages.searchEngineParagraph11)],
  },
  {
    header: messages.searchEngineHeader12,
    blocks: [getParagraphBlock(messages.searchEngineParagraph12)],
  },
  {
    header: messages.searchEngineHeader13,
    blocks: [
      getParagraphBlock(messages.searchEngineParagraph13),
      getParagraphBlock(messages.searchEngineSecondParagraph13),
    ],
  },
];

export const hightSchools: School[] = getListWithId([
  {
    name: 'Publiczne Liceum Ogólnokształcące Uniwersytetu Łódzkiego',
    place: 'w Łodzi',
  },
  {
    name: 'Liceum Ogólnokształcące "Szkoła Liderów"',
    place: 'w Warszawie',
  },
  {
    name: 'Liceum Ogólnokształcące im. Salvadora Dalego',
    place: 'w Warszawie',
  },
  {
    name: 'Publiczne Liceum Ogólnokształcące sióstr Salezjanek im. Świętego Dominika Savio',
    place: 'w Krakowie',
  },
  {
    name: 'Liceum Ogólnokształcące im. Matki J. Borzęckiej Zgromadzenia Sióstr Zmartwychwstania Pańskiego',
    place: 'w Poznaniu',
  },
  {
    name: 'Zespół Szkół Techniczno-Informatyczych',
    place: 'w Gliwicach',
  },
  {
    name: 'Zespół Szkół Rolniczo-Technicznych',
    place: 'w Zwoleniu',
  },
  {
    name: 'Zespół Szkół Technicznych i Ogólnokształcących im. Jana Pawła II',
    place: 'w Limanowej',
  },
  {
    name: 'Zespół Szkół nr 1 im. Bohaterów Westerplatte',
    place: 'w Garwolinie',
  },
  {
    name: 'Zespół Szkół Architektoniczno-projektowych im. Władysława Szafera',
    place: 'w Gdańsku',
  },
]);

export const primarySchools: School[] = getListWithId([
  {
    name: 'Szkoła Podstawowa im. rtm. Witolda Pileckiego',
    place: 'w Kornem',
  },
  {
    name: 'Szkoła Podstawowa nr 383 im. Księdza Stefana Kardynała Wyszyńskiego',
    place: 'w Warszawie',
  },
  {
    name: 'Publiczna Szkoła Podstawowa im. św. Jana Bosko z Oddziałami Przedszkolnymi',
    place: 'w Celinach',
  },
  {
    name: 'Sportowa Szkoła Podstawowa nr 14 im. Władysława Łokietka',
    place: 'w Poznaniu',
  },
  {
    name: 'Szkoła Podstawowa nr 12 im. gen. Mariusza Zaruskiego',
    place: 'w Gdyni',
  },
  {
    name: 'Publiczna Szkoła Podstawowa im. Bronisława Malinowskiego',
    place: 'w Gdyni',
  },
  {
    name: 'Szkoła Podstawowa im. Wincentego Witosa',
    place: 'w Woli Batorskiej',
  },
  {
    name: 'Szkoła Podstawowa im. prof. arch. Stanisława Marzyńskiego',
    place: 'w Rogotwórsku',
  },
  {
    name: 'Publiczna Szkoła Podstawowa Sióstr Salezjanek im. Błogosławionej Laury Vicuña',
    place: 'w Krakowie',
  },
  {
    name: 'Publiczna Szkoła Podstawowa Sióstr Salezjanek im. Błogosławionej Laury Vicuña',
    place: 'w Rudnikach',
  },
]);
